(function() {
    'use strict';
    angular
        .module('serviciosocialApp')
        .factory('SSPerfil', SSPerfil);

    SSPerfil.$inject = ['$resource', 'DateUtils'];

    function SSPerfil ($resource, DateUtils) {
        var resourceUrl =  'api/s-s-perfils/:id';

        return $resource(resourceUrl, {}, {
            'query': { 
				method: 'GET', 
				isArray: true
			},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.altaReg = DateUtils.convertDateTimeFromServer(data.altaReg);
                        data.bajaReg = DateUtils.convertDateTimeFromServer(data.bajaReg);
                        data.ultActReg = DateUtils.convertDateTimeFromServer(data.ultActReg);
                    }
                    return data;
                }
            },
            'update': { 
				method:'PUT' 
			},
            'deactivate': { 
            	method:'PUT',
            	url:'api/s-s-perfils/deactivate', 
            },
            'reactivate': { 
            	method:'PUT',
            	url:'api/s-s-perfils/reactivate', 
            },
        });
    }
})();
